import React, {Component} from "react";
import {
    View,
    Image,
    TouchableOpacity,
    ActivityIndicator,
    Linking,
    BackHandler,
    FlatList
} from 'react-native'
import {icons} from "../theme/icons";
import {homeStyles, appStyles} from "../theme/styles";
import TextView from "../components/TextView";
import Button from "../components/Button";
import {
    advertisingsRequest,
    notifictionNumberRequest,
    getActiveRequest,
    versionAppRequest,
    walletInfoRequest,
    logoutRequest
} from "../utils/api";
import {wp, hp} from "../utils/responsive";
import DialogMessage from "../components/DialogMessage";
import {inject, observer} from "mobx-react";
import {showPromptDownload} from "../utils/utils";
import {clearUsers} from "../database/UserDal";

@inject('store')
@observer
export default class HomeScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notifiction: 0,
            showMessage: false,
            messageContent: '',
            messageTitle: '',
            slider_waiting: true,
            autoPlay: true,
            sliderIndex:0,
            sliders: []
        }
        this.flatListRef=null;
    }

    _keyExtractor = (item, index) => index.toString();

    renderSlider = ({item, index}) => {
        return <View key={index.toString()} style={homeStyles.sliderWraper}>
            <TouchableOpacity activeOpacity={1} style={[homeStyles.sliderItem]} onPress={() => {
                if (item.link != null && item.link.includes('http')) {
                    Linking.openURL(item.link).then(r => {
                    })
                }
            }}>
                <Image
                    source={{uri: item.nameimage}}
                    style={homeStyles.sliderImage}/>
            </TouchableOpacity>
        </View>
    }

    getItemLayout(data, index) {
        return {length: wp(85), offset: wp(85) * index, index};
    }

    render() {
        return (<View style={homeStyles.container}>
            <View style={appStyles.toolbarWraper}>
                <TouchableOpacity style={appStyles.row} onPress={() => {
                    this.setState({
                        notifiction: 0
                    })
                    this.props.navigation.navigate('notifiction')
                }}>
                    <Image source={icons['notifiction']} style={appStyles.toolbarIcon}/>
                    {this.state.notifiction > 0 ? <View style={homeStyles.notifictionWraper}>
                        <TextView style={homeStyles.notifictionCount}>{this.state.notifiction}</TextView>
                    </View> : null}
                </TouchableOpacity>
                <TextView style={appStyles.toolbarTitle}>آسان درمان</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.openDrawer()
                }}>
                    <Image source={icons['menu']} style={appStyles.toolbarIcon}/>
                </TouchableOpacity>
            </View>
            {!this.state.slider_waiting ? <View style={{height: hp(40)}}>
                    <FlatList
                        data={this.state.sliders}
                        ref={(flatListRef)=>this.flatListRef=flatListRef}
                        renderItem={this.renderSlider.bind(this)}
                        initialScrollIndex={0}
                        onScrollToIndexFailed={() => {
                        }}
                        keyExtractor={this._keyExtractor}
                        horizontal={true}
                        showsVerticalScrollIndicator={false}
                        snapToAlignment={"start"}
                        decelerationRate={"fast"}
                        getItemLayout={this.getItemLayout}
                        pagingEnabled
                    />
                </View> :
                <View style={[appStyles.center, homeStyles.slider]}>
                    <ActivityIndicator size="large" color="black"/></View>}

            <Button
                text='درخواست خدمات درمانی در منزل'
                style={homeStyles.requestButton}
                textStyle={appStyles.buttonText}
                onPress={() => {
                    this.props.store.changeAutoPlay(false)
                    this.props.navigation.navigate('customerLocation')
                    // this.props.navigation.navigate('viewCart')
                }}
            />

            <DialogMessage
                show={this.state.showMessage}
                title={this.state.messageTitle}
                message={this.state.messageContent}
                onClose={() => {
                    this.setState({
                        showMessage: false
                    })

                }}/>
        </View>)
    }


    componentWillMount() {

        advertisingsRequest((isConnect, response) => {
            this.setState({
                slider_waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    sliders: response.data
                })
            }
        })

        notifictionNumberRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
                this.setState({
                    notifiction: response.data.number
                })
            }
        })

        getActiveRequest((isConnect, response) => {
            if (isConnect && response.isSuccess && response.data != null && response.data.idorder != null) {
                this.props.navigation.navigate('requestInfo', {
                   id: response.data.idorder,
                    onRefresh: () => {
                        console.log('')
                    }
                })
            }
        })
        versionAppRequest((isConnect, response) => {
            if (isConnect && response.data.isSuccess) {
                if (parseFloat(response.data.data.version) > 5) {
                    showPromptDownload('ورژن جدید', response.data.data.comment, () => {
                        Linking.openURL(response.data.data.linkapp);
                    }, () => {
                        if (response.data.data.needupdate == 'yes') {
                            BackHandler.exitApp();
                        }
                    }, response.data.data.needupdate)
                }
            } else {
                if (response?.message?.includes('403')) {
                    logoutRequest((isConnect, response) => {
                        clearUsers();
                        Linking.openURL('https://client.asandarman.ir');
                    })
                }

            }
        })
        walletInfoRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
                this.props.store.changeWalletAmount(response.data.sharge);
            }
        })
    }

    componentDidMount() {
        setInterval(()=>{
            if(this.state.autoPlay && this.flatListRef!=null)
            {
                let index=this.state.sliderIndex;
                if(index===this.state.sliders.length-1)
                {
                    index=0;
                }else {
                    index++;
                }
                this.flatListRef.scrollToIndex({index:index,animated:true})
                this.setState({
                    sliderIndex:index
                })
            }
        },5000)
        this.props.navigation.addListener(
            'didFocus',
            payload => {
                this.props.store.changeAutoPlay(true)
                this.setState({
                    autoPlay: true,
                })
            })
        this.props.navigation.addListener(
            'didFocus',
            payload => {
                this.props.store.changeAutoPlay(true)
                this.setState({
                    autoPlay: true,
                })
            })
        this.props.navigation.addListener(
            'didBlur',
            payload => {
                this.props.store.changeAutoPlay(false)
                this.setState({
                    autoPlay: false,
                })
            })
        this.props.navigation.addListener(
            'didBlur',
            payload => {
                this.props.store.changeAutoPlay(false)
                this.setState({
                    autoPlay: false,
                })
            });
    }
}

